import { Box, Flex, Image } from "@chakra-ui/react"

export function CardImage({ item }) {
  return (
    <Flex flexDir="column" borderRadius="md" boxShadow="0 0 3px rgba(0,0,0,.1)">
      <Flex bgColor="#f5f5f5" minH="200px" maxH="400px">
        <Image src={item.link_imagem} alt="" objectFit={"cover"} w="100%" />
      </Flex>
      <Box bgColor="#f5f5f5" py={2} px={1} borderTop="1px solid #cecece">
        {item.nome_imagem.length > 50 ? (
          <Box as="span">{item.nome_imagem.substring(0, 50)}...</Box>
        ) : (
          <Box as="span">{item.nome_imagem}</Box>
        )}
      </Box>
    </Flex>
  )
}
